/*
 * Author: Dw
 * File Created: Tuesday, 24-10-29 09:43 pm
 * Last Modified: Wednesday, 24-11-20 06:08 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
const Forbidden = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Forbidden" data-sentry-source-file="index.tsx">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.127 18.3999C15.7229 19.5262 13.9401 20.2 12 20.2C7.47126 20.2 3.8 16.5287 3.8 12C3.8 10.0599 4.47379 8.27711 5.60013 6.87296L17.127 18.3999ZM18.3998 17.1271L6.87292 5.60016C8.27708 4.4738 10.0599 3.8 12 3.8C16.5287 3.8 20.2 7.47126 20.2 12C20.2 13.9401 19.5262 15.7229 18.3998 17.1271ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
};
export default Forbidden;